import React, { useContext, useState } from 'react';
import { Dropdown, Menu, Row, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Avatar } from '../../../../components/ui';
import { StyledMenu } from '../../styles';
import {
  clearTokenAndRefreshToken,
  isColaborador
} from '../../../../shared/util/utilToken';
import { papelBeautify } from '../../../../shared/util/enums/papelEnum';
import { situacaoEnum } from '../../../../shared/util/enums/situacaoEnum';
import { getSmallestImage } from '../../../../shared/util/imageUtils';
import { ContextPerson } from '../../../../store/contexts/contextPerson';
import AvatarPadrao from '../../../../images/svgs/avatar-padrao.svg';
import Config from '../../../../shared/Config';
import { shutdown } from '@intercom/messenger-js-sdk';
import styles from './ProfileMenu.module.css';

const { Text } = Typography;

export default function ProfileMenu(props) {
  const { personLoading } = useContext(ContextPerson);
  const history = useHistory();
  const { t } = useTranslation('header');
  const [, setIsOpenMenu] = useState(false);

  const {
    pessoa,
    vinculos: vinculosProp,
    setarPessoaAtual,
    setarPessoaAtualLoading,
    links,
    allowsAffiliate,
    okThirdSetup,
    setSeeAll
  } = props;

  let vinculos = [];
  let vinculoAtual = null;
  if (vinculosProp && vinculosProp.length) vinculos = vinculosProp;
  if (pessoa && pessoa.vinculo) vinculoAtual = pessoa.vinculo;

  const handleImageError = e => {
    e.target.src = AvatarPadrao;
  };
  const isPersonLoading = () => setarPessoaAtualLoading || personLoading;

  const empresaAtualId = () => {
    if (!vinculoAtual || !vinculoAtual.empresa || !vinculoAtual.empresa.id)
      return null;
    return vinculoAtual.empresa.id;
  };

  const fotoAtual = () => {
    let foto = AvatarPadrao;
    if (vinculoAtual && vinculoAtual.empresa && vinculoAtual.empresa.fotoUrl) {
      foto = getSmallestImage(
        vinculoAtual.empresa.fotoUrlResponsive,
        vinculoAtual.empresa.fotoUrl
      );
    }
    if (!vinculoAtual && pessoa && pessoa.fotoUrl) {
      foto = getSmallestImage(pessoa.fotoUrlResponsive, pessoa.fotoUrl);
    }
    return foto;
  };

  const canBecomeAffiliate = () =>
    !vinculoAtual &&
    pessoa &&
    !pessoa.afiliacao &&
    okThirdSetup &&
    !isColaborador();

  const isAffiliate = () => pessoa && pessoa.afiliacao && !vinculoAtual;

  /* eslint-disable no-restricted-syntax */
  const handleClick = e => {
    if (e.key === 'painel') history.push(links.painel);
    else if (e.key === 'cadastro-perfil-pf') history.push(links.editarPerfilPf);
    else if (e.key === 'cadastro-fornecedor')
      history.push(links.cadastroFornecedor);
    else if (e.key === 'perfil-pf') history.replace(links.verPerfilPf);
    else if (e.key === 'alterar-senha-pf')
      history.replace(links.alterarSenhaPf);
    else if (e.key === 'cadastro-perfil-pj') history.push(links.editarPerfilPj);
    else if (e.key === 'perfil-pj') history.replace(links.verPerfilPj);
    else if (e.key === 'home-afiliado') history.replace(links.homeAfiliado);
    else if (e.key === 'painel-afiliado') history.replace(links.painelAfiliado);
    else if (e.key === 'sair') {
      clearTokenAndRefreshToken();
      shutdown();
      setTimeout(() => {
        window.location.href = Config.baseUrl + links.sair;
      }, 0);
    } else {
      let empresa = vinculos.filter(p => p.id === e.key)[0];
      if (empresa) {
        if (empresa.etapaCadastroFornecedor === situacaoEnum.EM_CADASTRAMENTO) {
          history.push(
            links.cadastroFornecedor + '/' + empresa.vinculoPessoaEmpresaId
          );
        } else {
          setarPessoaAtual(empresa);
          setSeeAll(false);
        }
      } else if (e.key === pessoa.id) {
        setarPessoaAtual(null);
      }
    }
  };
  /* eslint-enable no-restricted-syntax */

  const menu = (
    <StyledMenu onClick={handleClick}>
      <Menu.Item className='menu-item__custom'>
        <div className='container-vinculos'>
          {pessoa && (
            <div
              style={{ fontWeight: '600 !important', minHeight: '50px' }}
              key={pessoa.id}
              onClick={() => handleClick({ key: pessoa.id })}
              className={
                !vinculoAtual
                  ? 'dropdown-menu-item-selected'
                  : 'dropdown-menu-item'
              }>
              <img
                src={
                  pessoa.fotoUrl
                    ? getSmallestImage(pessoa.fotoUrlResponsive, pessoa.fotoUrl)
                    : AvatarPadrao
                }
                className='avatar mr-2'
                alt={t('AVATAR_ALT') + (pessoa && pessoa.nome)}
                style={{ height: '48px', width: '48px' }}
                onError={handleImageError}
              />
              <Row
                justify='space-around'
                className='ant-row-flex flex-column'
                style={{ padding: '5px auto', fontWeight: '600 !important' }}>
                <div>
                  <Text
                    style={{ maxWidth: '210px' }}
                    ellipsis
                    className='nome-pessoa'>
                    {pessoa.nome}
                  </Text>
                </div>
                <div style={{ fontSize: '0.9em' }}>
                  <Text
                    style={{ maxWidth: '210px' }}
                    ellipsis
                    type='secondary'
                    className='nome-pessoa'>
                    {t('CLIENT')}
                  </Text>
                </div>
              </Row>
            </div>
          )}
          {vinculos &&
            vinculos.map(vinculo => (
              <div
                style={{ fontWeight: '600 !important', minHeight: '50px' }}
                key={vinculo.empresa.id}
                onClick={() => handleClick({ key: vinculo.empresa.id })}
                className={
                  vinculo.empresa.id === empresaAtualId()
                    ? 'dropdown-menu-item-selected'
                    : 'dropdown-menu-item'
                }>
                <img
                  src={
                    vinculo.empresa.fotoUrl
                      ? getSmallestImage(
                          vinculo.empresa.fotoUrlResponsive,
                          vinculo.empresa.fotoUrl
                        )
                      : AvatarPadrao
                  }
                  className='avatar mr-2'
                  alt={
                    t('AVATAR_ALT') +
                    (vinculo && vinculo.empresa && vinculo.empresa.nomeFantasia)
                  }
                  style={{ height: '48px', width: '48px' }}
                  onError={handleImageError}
                />
                <Row
                  justify='space-around'
                  className='ant-row-flex flex-column'
                  style={{ padding: '5px auto', fontWeight: '600 !important' }}>
                  <div>
                    <Text
                      style={{ maxWidth: '210px' }}
                      ellipsis
                      className='nome-pessoa'>
                      {pessoa.nome}
                    </Text>
                  </div>
                  <div style={{ fontSize: '0.9em' }}>
                    {vinculo.empresa && vinculo.empresa.nomeFantasia ? (
                      <Text
                        style={{ maxWidth: '130px' }}
                        ellipsis
                        type='secondary'
                        className='nome-empresa'>
                        {vinculo.empresa.nomeFantasia}
                      </Text>
                    ) : (
                      ' '
                    )}
                    {vinculo.empresa && vinculo.papel && vinculo.papel.nome ? (
                      <Text
                        style={{ maxWidth: '130px' }}
                        ellipsis
                        type='secondary'
                        className='nome-empresa'>
                        {` - ${papelBeautify(vinculo.papel.nome)}`}
                      </Text>
                    ) : (
                      ''
                    )}
                  </div>
                </Row>
              </div>
            ))}
        </div>
      </Menu.Item>

      {vinculoAtual && <Menu.Divider />}
      {vinculoAtual && (
        <Menu.Item key='cadastro-perfil-pj'>
          {t('EDIT_COMPANY_PROFILE')}
        </Menu.Item>
      )}
      {vinculoAtual && (
        <Menu.Item key='perfil-pj'>{t('VIEW_COMPANY_PROFILE')}</Menu.Item>
      )}
      <Menu.Divider />
      {pessoa && <Menu.Item key='painel'>{t('MY_DASHBOARD')}</Menu.Item>}
      {pessoa && (
        <Menu.Item key='cadastro-perfil-pf'>{t('EDIT_PROFILE')}</Menu.Item>
      )}
      {pessoa && <Menu.Item key='perfil-pf'>{t('VIEW_PROFILE')}</Menu.Item>}
      {pessoa && (
        <Menu.Item key='alterar-senha-pf'>{t('ALTERAR_SENHA')}</Menu.Item>
      )}
      <Menu.Divider />

      {canBecomeAffiliate() && allowsAffiliate && (
        <Menu.Item key='home-afiliado'>
          <Text className='spotlight-text'>{t('WANT_TO_BE_AFFILIATE')}</Text>
        </Menu.Item>
      )}
      {canBecomeAffiliate() && allowsAffiliate && <Menu.Divider />}
      {isAffiliate() && (
        <Menu.Item key='painel-afiliado'>{t('AFFILIATE_DASHBOARD')}</Menu.Item>
      )}
      {isAffiliate() && <Menu.Divider />}

      <Menu.Item key='sair'>
        <Text type='danger'>{t('EXIT')}</Text>
      </Menu.Item>
    </StyledMenu>
  );

  return (
    <Dropdown
      onOpenChange={e => setIsOpenMenu(e)}
      dropdownRender={() => menu}
      trigger={['click']}
      overlayStyle={{ position: 'fixed' }}
      placement='bottomRight'
      disabled={isPersonLoading()}>
      <div className={`${styles.trigger} ant-dropdown-link`}>
        <Avatar
          src={fotoAtual()}
          alt={t('AVATAR_ALT') + (pessoa && pessoa.nome)}
          onError={handleImageError}
          className={styles.avatar}
        />
      </div>
    </Dropdown>
  );
}
